import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "row", "container", "template" ]

  connect() {
    this.initialRender()
    this.form.addEventListener("turbo:submit-start", this.save.bind(this))
  }

  initialRender() {
    const initialData = JSON.parse(this.data.get("initialValue") || "{}")
    Object.entries(initialData).forEach(([key, value]) => {
      this.addRow(key, value)
    })
  }
  
  addNewRow(event) {
    event.preventDefault()
    this.addRow()
  }

  addRow(key = "", value = "") {
    const template = this.templateTarget.innerHTML
    const newRow = template
      .replace(/KEY_PLACEHOLDER/g, key)
      .replace(/VALUE_PLACEHOLDER/g, value)
    
    this.containerTarget.insertAdjacentHTML('beforeend', newRow)
  }

  removeRow(event) {
    const row = event.target.closest('[data-key-value-target="row"]')
    if (row) {
      row.remove()
    }
  }

  get form() {
    return this.element.closest('form')
  }

  get input() {
    return this.element.querySelector('input[type="hidden"]')
  }

  save() {
    const rows = this.containerTarget.querySelectorAll('[data-key-value-target="row"]')
    const data = Array.from(rows).reduce((acc, row) => {
      const key = row.querySelector('input[name="key"]').value
      const value = row.querySelector('input[name="value"]').value
      if (key) {
        acc[key] = value
      }
      return acc
    }, {})
    
    this.input.value = JSON.stringify(data, null, 2)
  }
}
